// https://codepen.io/JEE42/pen/rNbLoxb

/*
https://pzppzz.github.io/konvajs-image-crop-demo/
https://blog.intzone.com/using-konva-js-to-annotate-image-with-bounding-boxes/
*/


const baseUrl = "https://customcribboards.com/cdn/shop/files/";
let intervalId;
let pressTimer;
let dropZone = null;




Konva._fixTextRendering = true;





function groupItemTypes(items) {
  let layers = {
    baseLayerNode: null,
    imageNodes: [],
    textNodes: [],
    shapeNodes: []
  };

  //console.log("group items", items);
  items.forEach((item) => {
    if ((item.className === "Image" && item.attrs.type == "baseImage") || item.className === "BaseLayer") {
      layers.baseLayerNode = item;

    } else if ((item.className === "Image" && (item.attrs.type == "svgobject" || item.attrs.type == "imageupload")) || item.className === "Track") {
      layers.imageNodes.push(item);

    } else if (item.className === "Text" ||
      item.className === "QuadraticTextPathGroup" ||
      item.className === "BezierTextPathGroup" ||
      item.className === "SinewaveTextPath" ||
      item.className === "CircleTextPath" ||
      item.className === "EllipseTextPath" ||
      item.className === "RectangleTextPath" ||
      item.className === "SidedTextPath" ||
      item.className === "HeartTextPath" ||
      item.className === "StarTextPath" ||
      item.className === "TeardropTextPath" ||
      item.className === "SpiralTextPath" ||
      item.className === "SquareSpiralTextPath"
    ) {
      layers.textNodes.push(item);

    } else if (item.className === "Rect" ||
      item.className === "Circle" ||
      item.className === "Ellipse" ||
      item.className === "Star" ||
      item.className === "Arrow" ||
      item.className === "Wedge" ||
      item.className === "Arc" ||
      item.className === "HeartShape" ||
      item.className === "TeardropShape" ||
      item.className === "RegularPolygon") {
      layers.shapeNodes.push(item);

    }
  });

  //console.log("groupItemTypes", layers);

  return layers;
}


// Define a custom Konva filter
Konva.Filters.WhiteToTransparent = function (imageData) {
  const data = imageData.data; // This is a Uint8ClampedArray: [R, G, B, A, R, G, B, A, ...]
  const len = data.length;

  // Define a tolerance for what is considered "white"
  // Pure white is R=255, G=255, B=255
  const tolerance = 10; // Adjust this value (0-255) to be more or less lenient

  for (let i = 0; i < len; i += 4) {
    const r = data[i]; // Red component
    const g = data[i + 1]; // Green component
    const b = data[i + 2]; // Blue component
    // const a = data[i + 3]; // Alpha component (0-255)

    // Check if the pixel is close to white within the defined tolerance
    if (r >= 255 - tolerance && g >= 255 - tolerance && b >= 255 - tolerance) {
      data[i + 3] = 0; // Set alpha to 0 (fully transparent)
    }
  }
};


//function addSvgImage(svgString, x, y, type, group, width, height) {
function addSvgImage(svgString, x, y, config = {}) {
  //console.log("addSvgImage", x, y, config);

  if (config.type !== "cutout") {
    //console.log("addSvgImage cutout", config);

    let svgGroup = new MultiPathSVGGroup({svgString: svgString, group: config.group});

    svgGroup.x(100);
    svgGroup.y(100);

    app.getLayer().add(svgGroup);
    app.getLayer().batchDraw();
    app.selectNode(svgGroup); 
    app.resetTrackIndex();
    return svgGroup;
  }
  

  
  if (config.type === "cutout") {
    let cutoutImage = new CutoutImage({svgString: svgString, layer: layer});
    /*
    cutoutImage.x(100);
    cutoutImage.y(100);

    layer.add(cutoutImage);
    cutoutImage.setZIndex(1);
    layer.batchDraw();
    app.selectNode(cutoutImage); 
    app.resetTrackIndex();
    return cutoutImage;
    */
  }
}


function addSVGImageFromURL(svgUrl, dataset) {
  console.log("addSVGImageFromURL", svgUrl, dataset);

  Konva.Image.fromURL(
    svgUrl,
    function (imageNode) {
      if (dataset.group == "Tracks" && app.getCanAddTrack() == false) {
        return;
      }

      if (dataset.group == "Tracks" && app.getTrack() != null) {
        app.destroyTrack();
      }

      doGetSvgFromUrl(svgUrl, {
        width: imageNode.width() * (72 / 96),
        height: imageNode.height() * (72 / 96),
        draggable: false,
        isFlipped: false,
        name: svgUrl,
        //scale: {x: getBaseLayerScale(), y: getBaseLayerScale()},
        //type: 'svgobject',
        type: dataset.type,
        group: dataset.group,
        numberLanes: dataset.lanes,
        sortable: dataset.group === "Tracks" ? false : true,
      });
    },

    (error) => {
      console.error("Error loading SVG:", error);
    }
  );
}


async function getSvgStringFromUrl(url) {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const svgString = await response.text();

    return svgString;
  } catch (error) {
    console.error("Error fetching SVG:", error);
    return null;
  }
}


function doGetSvgFromUrl(svgUrl, config) {
  //console.log("doGetSvgFromUrl get", svgUrl, config);

  getSvgStringFromUrl(svgUrl).then((svgString) => {
    if (svgString) {
      //console.log("doGetSvgFromUrl gotSvg", svgString);
      addSvgImage(svgString, config.x ?? 60 + app.getBaseLayer().width() / 2, config.y ?? 60 + app.getBaseLayer().height() / 2, config);
    }
  });
}


function createDesignThumbnail() {
  app.selectNone();

  return new Promise(function (resolve, reject) {
    const originalDataURI = trimCanvas().toDataURL({ pixelRatio: 2 });
    //console.log("originalDataURI");
    //console.log(originalDataURI);

    var memoryImg = document.createElement('img');
    memoryImg.src = originalDataURI;
    let resizedDataURI = "";

    memoryImg.onload = function () {
      //console.log("memoryImg Loaded");

      var width = memoryImg.width;
      var height = memoryImg.height;
      //console.log("getImageDataURIDimensions", {"width": width, "height": height});

      let originalWidth = width;
      let originalHeight = height;

      let maxWidth = 200; // Example: desired maximum width
      let newWidth = originalWidth;
      let newHeight = originalHeight;

      //console.log("originalWidth, maxWidth", originalWidth, maxWidth);
      // If the image is wider than the max width
      if (originalWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = (originalHeight * maxWidth) / originalWidth;
      }
      //console.log("newWidth, newHeight", newWidth, newHeight);

      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(memoryImg, 0, 0, newWidth, newHeight);
      resizedDataURI = canvas.toDataURL('image/png', 100);

      //return resizedDataURI;
    };

    resolve(resizedDataURI);
  });

}


function parseImage(layerJson) {
  //console.log("parseImage", layerJson);

  //does some stuff with the data
  return new Promise(function (resolve, reject) {
    var width = layerJson.image.width;
    var height = layerJson.image.height;
    //console.log("getImageDataURIDimensions", {"width": width, "height": height});

    let originalWidth = width;
    let originalHeight = height;

    let maxWidth = 200; // Example: desired maximum width
    let newWidth = originalWidth;
    let newHeight = originalHeight;

    //console.log("originalWidth, maxWidth", originalWidth, maxWidth);
    // If the image is wider than the max width
    if (originalWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = (originalHeight * maxWidth) / originalWidth;
    }
    //console.log("newWidth, newHeight", newWidth, newHeight);

    layerJson.imageWidth = newWidth;
    layerJson.imageHeight = newHeight;

    resolve(layerJson);
  })
}


function createThumb(layerJson) {
  //console.log("createThumb", layerJson);

  //validates the data
  return new Promise(function (resolve, reject) {
    const canvas = document.createElement('canvas');
    canvas.width = layerJson.imageWidth;
    canvas.height = layerJson.imageHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(layerJson.image, 0, 0, layerJson.imageWidth, layerJson.imageHeight);
    resizedDataURI = canvas.toDataURL('image/png', 100);
    layerJson.image = resizedDataURI;

    resolve(layerJson);
  });
}


function saveThumb(layerJson) {
  //debugger;
  //console.log("saveThumb - typeof", typeof layerJson);
  //console.log("saveThumb - layerJson", layerJson);
  let name = layerJson.name;
  //var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(layerJson);
  var dataStr = JSON.stringify(layerJson);
  //console.log("saveThumb - dataStr", dataStr);
  app.fileMenu.saveDesignToLocalStorage(app.getDesignNamePrefix() + layerJson.name, dataStr);
}


//The function that orchestrates these calls 
function thumbRunner(layerJson) {
  //console.log("thumbRunner", layerJson);

  return getMemoryImage(layerJson)
    .then(parseImage)
    .then(createThumb)
    .then(saveThumb)
}


function loadImage(url) {
  return new Promise((resolve, reject) => {
    const imageObj = new Image();
    imageObj.onload = () => resolve(imageObj);
    imageObj.onerror = (error) => reject(error);
    imageObj.src = url;
  });
}


async function addImageToKonvaLayer(imageUrl, konvaLayer) {
  try {
    const loadedImage = await loadImage(imageUrl);
    //console.log("addImageToKonvaLayer", loadedImage);
    // Create a Konva.Image shape with the loaded image
    const konvaImage = new Konva.Image({
      image: loadedImage,
      x: 50, // Example position
      y: 50,
      width: loadedImage.width,
      height: loadedImage.height,
    });

    // Add the Konva.Image to the Konva layer
    konvaLayer.add(konvaImage);
    konvaLayer.batchDraw(); // Redraw the layer to display the image

  } catch (error) {
    console.error('Error loading image:', error);
  }
}


document.getElementById("estimate_price").addEventListener("click", (event) => {
  let price = app.calculateDesignCost();

  const formatterUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  const formattedUSD = formatterUSD.format(price);

  showMessage("Estimated Price", "Estimated price to build this customized Cribbage Board is " + formattedUSD);
});


function layerFromJSON(json) {
  //console.log("layerFromJSON", json);

  app.selectNone();

  designName = json.name;

  let items = app.getLayer().getChildren();
  items.forEach((item) => {
    if (item.className !== "Transformer") {
      item.destroy();
    }
  });

  let children = json.children;
  let groupedItems = groupItemTypes(children);
  //console.log("layerFromJSON groupedItems", groupedItems);

  promiseLoadDesign(groupedItems);
}


function promiseLoadBaseLayerNode(items) {
  //console.log("promiseLoadBaseLayerNode", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    //console.log("promiseLoadBaseLayerNode Image", items);
    app.loadBaseImage(items.baseLayerNode.attrs.name, items.baseLayerNode.attrs);
    //console.log("getBaseLayerScale: ", getBaseLayerScale());

    resolve(items);

  });
}


function promiseLoadImageNodes(items) {
  //console.log("promiseLoadImageNodes", items);
  //console.log("getBaseLayerScale:", getBaseLayerScale());
  //console.log("getBaseLayer:", app.getBaseLayer());
  //console.log("Layer:", layer);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.imageNodes.forEach((item) => {

      //console.log("promiseLoadImageNodes Add Item", item.attrs.name, item.attrs);

      if (item.className === "Image" && item.attrs.type == "imageupload") {
        promiseAddUploadedImage(item.attrs.imageURI, item.attrs);
      } else if ((item.className === "Image" && item.attrs.type == "svgobject") || item.className === "Track") {
        if (getFileExtension(item.attrs.name) == "svg") {
          promiseDoGetSvgFromUrl(item.attrs.name, item.attrs);
        } else {
          promiseAddImage(item.attrs.name, item.attrs);
        }
      }

    });

    resolve(items);
  });
}


function promiseDoGetSvgFromUrl(svgUrl, config) {  
  //console.log("doGetSvgFromUrl get", svgUrl, config);

  promiseGetSvgStringFromUrl(svgUrl).then((svgString) => {
    if (svgString) {
      //console.log("doGetSvgFromUrl gotSvg", svgString);
      promiseAddSvgImage(svgString, config);
    }
  });
}


function promiseAddImage(imageUrl, config) {
  //console.log("promiseAddImage", config);

  Konva.Image.fromURL(imageUrl, (imageNode) => {
    //console.log("promiseAddImage loaded", config, imageUrl, imageNode);

    imageNode.draggable(true);

    imageNode.setAttrs({
      type: config.type ?? "image",
      name: config.name ?? "",
      group: config.group ?? "",
      numberLanes: parseInt(config.numberLanes) ?? 4,
      scaleX: config.scaleX ?? 1,
      scaleY: config.scaleY ?? 1,
      x: config.x ?? 60,
      y: config.y ?? 60,
      offsetX: config.offsetX ?? 0,
      offsetY: config.offsetY ?? 0,
      sortable: config.group === "Tracks" ? false : true,
    });

    if (config.group === "Tracks") {
      imageNode.moveToBottom();
      imageNode.moveUp();
      imageNode.className = "Track";  
    }

    imageNode.cache();
    imageNode.filters([Konva.Filters.Grayscale]);

    app.getLayer().add(imageNode);

    if (config.rotation) {
      imageNode.setRotation(config.rotation);
    }

    app.getLayer().batchDraw();
    app.selectNode(imageNode);
    app.resetTrackIndex();
  });
}


function promiseAddUploadedImage(imageURI, config) {
  if (!imageURI) {
    console.error("No imageURI found for uploaded image");
    return;
  }

  Konva.Image.fromURL(imageURI, (imageNode) => {
    imageNode.draggable(true);

    imageNode.setAttrs(config);

    imageNode.filters([
      Konva.Filters.Grayscale,
      Konva.Filters.WhiteToTransparent,
    ]);
    imageNode.cache();

    app.getLayer().add(imageNode);
    app.getLayer().batchDraw();
    app.selectNode(imageNode);
    app.resetTrackIndex();
  });
}


function promiseAddSvgImage(svgString, config) {
  //console.log("promiseAddSvgImage", config, svgString);

  const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "#37393B"), "stroke", "#37393B");
  const base64Svg = removeXmlDeclaration(btoa(unescape(encodeURIComponent(blackStr))));
  const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;

  Konva.Image.fromURL(dataUrl, (imageNode) => {
    //console.log("promiseAddSvgImage loaded", config, svgString, imageNode);

    imageNode.draggable(true);

    imageNode.setAttrs({
      type: config.type ?? "svgobject",
      name: config.name ?? "",
      group: config.group ?? "",
      numberLanes: parseInt(config.numberLanes) ?? 4,
      width: config.width ?? 100,
      height: config.height ?? 100,
      scaleX: config.scaleX ?? 1,
      scaleY: config.scaleY ?? 1,
      x: config.x ?? 60,
      y: config.y ?? 60,
      offsetX: config.offsetX ?? 0,
      offsetY: config.offsetY ?? 0,
      sortable: config.group === "Tracks" ? false : true,
    });

    app.getLayer().add(imageNode);
    //layer.children[layer.children.length-1].moveToBottom();
    //layer.children[0].moveUp();

    if (config.rotation) {
      imageNode.setRotation(config.rotation);
    }

    app.getLayer().batchDraw();
    app.selectNode(imageNode);
    app.resetTrackIndex();
  });
}


function promiseLoadTextNodes(items) {
  //console.log("promiseLoadTextNodes", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.textNodes.forEach((item) => {

      //console.log("promiseLoadTextNodes Add Text item", item.className, item);

      switch (item.className) {

        case "Text":
          app.textMenu.createTextNode(item.attrs);
          break;

        case "SinewaveTextPath":
          app.textMenu.createSinewaveTextPathNode(item.attrs);
          break;

        case "CircleTextPath":
          app.textMenu.createCircleTextPathNode(item.attrs);
          break;

        case "EllipseTextPath":
          app.textMenu.createEllipseTextPathNode(item.attrs);
          break;

        case "RectangleTextPath":
          app.textMenu.createRectangleTextPathNode(item.attrs);
          break;

        case "SidedTextPath":
          app.textMenu.createSidedTextPathNode(item.attrs);
          break;

        case "HeartTextPath":
          app.textMenu.createHeartTextPathNode(item.attrs);
          break;

        case "StarTextPath":
          app.textMenu.createStarTextPathNode(item.attrs);
          break;

        case "TeardropTextPath":
          app.textMenu.createTeardropTextPathNode(item.attrs);
          break;

        case "SpiralTextPath":
          app.textMenu.createSpiralTextPathNode(item.attrs);
          break;

        case "SquareSpiralTextPath":
          app.textMenu.createSquareSpiralTextPathNode(item.attrs);
          break;

        case "BezierTextPathGroup":
          app.textMenu.createBezierTextPathGroupNode(item.attrs);
          break;

        case "QuadraticTextPathGroup":
          app.textMenu.createQuadraticTextPathGroupNode(item.attrs);
          break;

      }

    });

    resolve(items);

  });
}


function promiseLoadShapeNodes(items) {
  //console.log("promiseLoadShapeNodes", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.shapeNodes.forEach((item) => {

      //console.log("promiseLoadShapeNodes Add Shape item", item.className, item);

      switch (item.className) {

        case "Rect":
          app.imagesMenu.addShapeRectangle(item.attrs);
          break;

        case "Circle":
          app.imagesMenu.addShapeCircle(item.attrs);
          break;

        case "Ellipse":
          app.imagesMenu.addShapeEllipse(item.attrs);
          break;

        case "Star":
          app.imagesMenu.addShapeStar(item.attrs);
          break;

        case "Arrow":
          app.imagesMenu.addShapeArrow(item.attrs);
          break;

        case "RegularPolygon":
          app.imagesMenu.addShapeMultiSided(item.attrs);
          break;

        case "Wedge":
          app.imagesMenu.addShapeWedge(item.attrs);
          break;

        case "Arc":
          app.imagesMenu.addShapeArc(item.attrs);
          break;

        case "HeartShape":
          app.imagesMenu.addShapeHeart(item.attrs);
          break;

        case "TeardropShape":
          app.imagesMenu.addShapeTeardrop(item.attrs);
          break;

      }

    });

    resolve(items);

  });
}


function promiseProcessBaseLayer(items) {
  //console.log("promiseProcessBaseLayer");

  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      //console.log("promiseProcessBaseLayer layer", layer);
      //console.log("promiseProcessBaseLayer getBaseLayer", app.getBaseLayer());
      //console.log("promiseProcessBaseLayer getBaseLayerScale", getBaseLayerScale());  
    }, 2000);

    resolve(items);
  });
}


function promiseScaleImages(items) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      //console.log("promiseScaleImages");
      //c//consoleonsole.log("promiseScaleImages layer", layer);
      //console.log("promiseScaleImages getBaseLayer", app.getBaseLayer());
      //console.log("promiseScaleImages getBaseLayerScale", getBaseLayerScale());  

      let images = getImageLayers();
      //console.log("images", images);

      images.forEach((img) => {
        img.scale({
          x: getBaseLayerScale() - (img.getScaleX() * getBaseLayerScale()),
          y: getBaseLayerScale() - (img.getScaleY() * getBaseLayerScale())
        });
      });

      app.getLayer().batchDraw();
    }, 2000);

    resolve(items);
  });
}


//The function that orchestrates these calls 
function promiseLoadDesign(items) {
  //console.log("promiseLoadDesign", items);

  return promiseLoadBaseLayerNode(items)
    .then(promiseProcessBaseLayer)
    .then(promiseLoadImageNodes)
    .then(promiseLoadTextNodes)
    .then(promiseLoadShapeNodes)
  //.then(promiseScaleImages)
}


  